import { render, staticRenderFns } from "./AwardBox.vue?vue&type=template&id=25d13cb6&"
import script from "./AwardBox.vue?vue&type=script&lang=ts&"
export * from "./AwardBox.vue?vue&type=script&lang=ts&"
import style0 from "./AwardBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports